import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { GrundstueckId } from '../../../../core/gb-api';
import { ComparatorService } from '../../../services/comparator-service';
import { AuftragListEntryMeta, AuftragService, LoadAuftragSichtByGrundstueckIdsRequest } from '../../../../core/auftrag-api';
import { AbstractComponent } from '../../abstract-component/abstract.component';
import { SortDirection, TableSortModel } from '../../../tablesort/tableSortModel';
import { ListLoader } from '../../list-loader/list-loader';
import { map } from 'rxjs/operators';
import { ListLoaderObservable } from '../../list-loader/list-loader-observable';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ListLoaderWrapperComponent } from '../../list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnHeaderComponent } from '../../../tablesort/sort-icon/column-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DatumPipe } from '../../../pipes/simple/datum.pipe';

@Component({
  selector: 'cap-haengige-auftraege',
  templateUrl: './haengige-auftraege.component.html',
  styleUrls: ['./haengige-auftraege.component.scss'],
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, ColumnHeaderComponent, TranslatePipe, DatumPipe]
})
export class HaengigeAuftraegeComponent extends AbstractComponent implements OnDestroy, OnChanges, OnDestroy {
  @Input()
  perimeter: Array<GrundstueckId>;
  @Input()
  hasRight = true;

  haengigeLoader: ListLoader<AuftragListEntryMeta>;

  protected tableSortModel = new TableSortModel<AuftragListEntryMeta>('haengige-auftraege', this.comparatorService);
  _loadOption;

  constructor(
    private auftragService: AuftragService,
    private comparatorService: ComparatorService
  ) {
    super();
    keysToTranslate<string>(['Auftrags-Nr']);
    this.tableSortModel
      .addColumn('auftragsNr', (a, b) => this.comparatorService.orderByComparator(a.auftragNummer, b.auftragNummer))
      .changeSortMode(SortDirection.DESC);
    this.tableSortModel.addColumn('status', (a, b) => this.comparatorService.orderByComparator(a.status, b.status));
    this.tableSortModel.addColumn('erstellDatum', (a, b) => this.comparatorService.orderByComparator(a.erstellDatum, b.erstellDatum));
    this.tableSortModel.addColumn('beschreibung', (a, b) => this.comparatorService.orderByComparator(a.beschreibung, b.beschreibung));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.perimeter && changes.perimeter.currentValue && this.perimeter) {
      this.updateLoader();
    }
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    if (this.haengigeLoader) {
      this.haengigeLoader.unsubscribeAll();
    }
  }

  @Input()
  set loadOption(value: string) {
    if (!value) {
      return;
    }
    this._loadOption = value;
  }

  get loadOption() {
    return this._loadOption;
  }

  private updateLoader() {
    if (this.haengigeLoader) {
      this.haengigeLoader.unsubscribeAll();
    }
    if (!this.hasRight || !this.perimeter) {
      return;
    }
    if (this.perimeter.length === 1) {
      this.haengigeLoader = this.createAuftragByGrundstueckIdLoader();
    } else {
      this.haengigeLoader = this.createAuftragByGrundstueckIdsLoader();
    }
    this.haengigeLoader.applySortModel(this.tableSortModel);
  }

  private createAuftragByGrundstueckIdLoader(): ListLoader<AuftragListEntryMeta> {
    const observable = this.auftragService.loadSichtByGrundstueckId(this.perimeter[0].id, this._loadOption).pipe(map((e) => e.results));
    const loader = new ListLoaderObservable<AuftragListEntryMeta>(15, 1, observable);
    this.addLoader(loader);
    return loader;
  }

  private createAuftragByGrundstueckIdsLoader(): ListLoader<AuftragListEntryMeta> {
    const request = <LoadAuftragSichtByGrundstueckIdsRequest>{
      grundstueckIds: this.perimeter,
      auftragLoadOption: this._loadOption
    };
    const observable = this.auftragService.loadSichtByGrundstueckIds(request).pipe(map((e) => e.results));
    const loader = new ListLoaderObservable<AuftragListEntryMeta>(15, 1, observable);
    this.addLoader(loader);
    return loader;
  }
}
